/**
 * A face photo as it is kept: the middle square of what the camera took, at most `size` pixels a side, as a JPEG —
 * a phone's photo is several megabytes, an avatar shown all over the apps a few dozen kilobytes. EXIF rotation is
 * applied by the browser while decoding
 */
export async function squarePhoto(file: File, size = 512): Promise<File> {
  const bitmap = await createImageBitmap(file)
  const side = Math.min(bitmap.width, bitmap.height)
  const out = Math.min(size, side)
  const canvas = document.createElement('canvas')
  canvas.width = out
  canvas.height = out
  const context = canvas.getContext('2d')
  if (!context) throw new Error('canvas')
  context.drawImage(bitmap, (bitmap.width - side) / 2, (bitmap.height - side) / 2, side, side, 0, 0, out, out)
  bitmap.close()
  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85))
  if (!blob) throw new Error('jpeg')
  return new File([blob], 'photo.jpg', { type: 'image/jpeg' })
}
